import { isArsMasterReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { cloneDeep } from "lodash";
import { checkChanged } from "./checkChanged";
import { ITlfActionLoadTlf, TlfContextProps } from "./interface";
import { toArsTlfSnapshot } from "./toArsTlfSnapshot";

/**
 * Loads TLF data into context and resets undo/save history for the new item.
 *
 * @param state - Current TLF context state.
 * @param action - Load action containing the next TLF payload and view flags.
 * @returns Updated state initialised from the loaded TLF item.
 */
export const tlf_loadTlf = (state: TlfContextProps, action: ITlfActionLoadTlf): TlfContextProps => {
  const newState = { ...state };

  newState.isSubscribed = action.isSubscribed;
  newState.isTlfNew = action.isTlfNew;
  newState.activeVariantPatchName = null;
  newState.activeVariantPatchInvalidOps = [];
  newState.appliedVariantPatches = [];
  newState.showCreateVariantPatchWindow = false;
  newState.variantCreationView = false;
  newState.ixSaveVersion = 0;
  newState.ixTlfDataVersion = 0;
  newState.masterTlfData = isArsMasterReadDto(action.tlfData)
    ? cloneDeep(toArsTlfSnapshot(action.tlfData))
    : null;
  newState.readOnly = action.readOnly;
  newState.showModalWindow = "";
  newState.tlfData = action.tlfData;
  newState.tlfDataVersions = [cloneDeep(action.tlfData)];
  newState.variantPatchSelectionVersions = [
    { appliedVariantPatches: [], activeVariantPatchName: null },
  ];
  checkChanged(newState);

  return newState;
};
